import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { Base } from '@adornis/buildify/db/Base.js';

@Entity()
export class BaseEditExtension extends Base {
  static override _class = 'BaseEditExtension';

  @Field(() => Boolean)
  public open: Maybe<boolean>;
}
